// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-module--container--1Somg","wrapper":"Footer-module--wrapper--31Tp3","copyright":"Footer-module--copyright--TXUCb"};